/**
 * ★★ WO — A AUTORIA DE UMA INTERAÇÃO DA TIMELINE, NUM LUGAR SÓ. Puro.
 *
 * ⚠⚠ ESTE MÓDULO NASCEU DE UM ACHADO DO BLOCO A, e o plano estava errado sobre ele.
 *
 * O plano dizia que `autoria()` em `leadsService.js:67` era "o lugar único" por onde toda
 * interação da tela passa. **Não era.** A varredura achou TRÊS serviços gravando em
 * `interacoes`, e dois deles montavam o trio `{autorId, autorNome, criadoEm}` à mão:
 *
 *     leadsService.js        11 chamadas  — via autoria()
 *     tarefasService.js       3 escritas  — à mão
 *     agendamentosService.js  7 escritas  — à mão
 *
 * ★★ POR QUE ISSO ERA BLOQUEANTE: o lote 1 acrescenta a cláusula
 * `request.resource.data.clinicaId == clinicaId` no `create` de `interacoes`. Com os dois
 * serviços gravando sem o campo, **criar tarefa, concluir tarefa, reagendar, cancelar
 * agendamento e dar baixa passariam a FALHAR em produção** no instante em que a regra subisse.
 *
 * ★ A saída não foi copiar o campo em dez lugares: foi fazer deste módulo o lugar único de
 * verdade, e trancá-lo com guarda de fonte (`wo.autoria.guardas.test.js`).
 *
 * ★ `carimbo` vem por PARÂMETRO — é o que mantém o módulo puro e testável sem emulador, o
 * mesmo padrão de `camposDoComparecimento` (`leads/comparecimento.js`).
 */

/**
 * Os campos de autoria de uma interação.
 *
 * @param autor        `{ id, nome }` de quem agiu; ausente = 'sistema'
 * @param clinicaId    ★★ OBRIGATÓRIO — é o tenant que a regra de collectionGroup confere
 * @param lead         o lead no estado ANTES da escrita, para `etapaNoMomento`
 * @param carimbo      a função de timestamp do servidor (`serverTimestamp`)
 */
export function autoria(autor, { clinicaId, lead = null, carimbo } = {}) {
  /**
   * ★★ FALHA ALTO, NÃO CALADA. Sem `clinicaId` o documento seria recusado pela regra nova —
   * e o erro apareceria para a recepcionista como "sem permissão", longe da causa. Aqui ele
   * aparece para quem escreveu a chamada, no primeiro teste que a exercitar.
   */
  if (typeof clinicaId !== 'string' || clinicaId === '') {
    throw new Error('autoria: clinicaId é obrigatório na interação (a regra de collectionGroup o exige).');
  }
  if (typeof carimbo !== 'function') {
    throw new Error('autoria: carimbo (serverTimestamp) é obrigatório.');
  }
  return {
    autorId: autor?.id ?? 'sistema',
    autorNome: autor?.nome ?? 'Sistema',
    criadoEm: carimbo(),
    // ★ O tenant. Sem ele um collectionGroup atravessaria clínicas — a invariante do projeto.
    clinicaId,
    /**
     * ★ A etapa do lead NO MOMENTO do registro.
     *
     * Resolve a ressalva medida na `wo-medicao.md` §5: o follow-up do negociador hoje só pode
     * ser contado pela etapa de HOJE, não pela da época. ⚠ As ~13 mil interações antigas
     * ficam sem o campo (o carimbo não o recupera — inventá-lo seria reconstrução, não
     * carimbo), e o cálculo cai na reserva da etapa atual, marcando a aproximação.
     */
    etapaNoMomento: lead?.etapa ?? null,
  };
}
